import { Directive, Renderer2, ElementRef, HostListener, OnInit } from '@angular/core';

@Directive({
  selector: '[dopAutoResize]'
})
export class AutoResizeDirective implements OnInit {

  CHARACTER_COUNT = 22;
  INITIAL_ROW = 3;

  prevRowCount: number;
  currentRowCount: number;

  constructor(private renderer: Renderer2, private elementRef: ElementRef) { }

  ngOnInit(): void {
    setTimeout(() => {
      const element = this.elementRef.nativeElement;
      element.style.overflow = 'hidden';
    });
  }

  @HostListener('input', ['$event']) input(e) {
    this.updateTextArea();
  }

  updateTextArea() {
    const element = this.elementRef.nativeElement;
    this.currentRowCount = Math.floor(element.value.length / this.CHARACTER_COUNT);
    if (element.offsetHeight < element.scrollHeight) {
      element.style.height = element.scrollHeight + 'px';
    }
    if (this.prevRowCount > 0 && this.prevRowCount > this.currentRowCount) {
      element.style.height = (element.scrollHeight - 13) + 'px';
    }
    if (element.value.length === 0 || this.currentRowCount < 1) {
      element.style.height = '38px';
    }
    this.prevRowCount = this.currentRowCount;
  }

}
